<template>
  <div v-if="parentEntity">
    <right-panel class="float-right" id="sidebar-new-asset-group" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form :product="product" @onAdminChanged="onAdminChanged" />
      </div>
    </right-panel>

    <div class="ds-card">
      <div class="ds-card--title">
        <div class="d-flex">
          <div class="">
            <span>
              <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
              {{ $t("asset-group.organization") }}
            </span>
          </div>
          <div class="">
            <div class="search2 ml-4 mb-4" style=" width: 18.50rem;">
              <div class="search2--icon"><i class="iconoir-search"></i></div>
              <input class="search2--input" type="text" :placeholder="$t('asset-group.search')" v-model="nameFilter" />
            </div>
          </div>
        </div>
        <div class="d-flex ml-auto mb-2">
          <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
            <div class="d-flex align-items-center">
              <label class="switch-label">{{ $t("common.recommendations") }}</label>
              <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination">
        <div class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
          <div v-for="item in pagination.docs" :key="item._id" :id="'popover-target-' + item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
            <div class="text">{{ item.name | translate }}</div>
            <div class="actions d-flex justify-content-center">
              <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
                <i class="iconoir-trash"></i>
              </div>

              <div class="action" @click="edit(item)" v-on:click.stop v-b-toggle="'sidebar-edit-organization-asset-group'" v-b-tooltip.hover :title="$t('common.edit')">
                <i class="iconoir-edit-pencil"></i>
              </div>

              <div v-if="product == 'DDO'" class="action" @click="redirectToSurvey(item)" v-b-tooltip.hover :title="$t('asset-group-survey.plural')">
                <i class="iconoir-star"></i>
              </div>
            </div>

            <b-popover :target="'popover-target-' + item._id" triggers="hover" placement="bottom" variant="secondary">
              <template #title> {{ $t("asset-group.admins") }}</template>
              <table>
                <tr v-for="admin in item.admins" :key="'asset-group-admin' + admin._id">
                  <td><letter-avatar :name="admin.account.name" :image="admin.account.avatar" variant="secondary" /></td>
                  <td class="text-center">{{ admin.account.name }}</td>
                </tr>
                <tr v-if="!item.admins || item.admins.length < 1">
                  <span>
                    <b>
                      {{ $t("asset-group.no-admin") }}
                    </b>
                  </span>
                </tr>
              </table>
            </b-popover>
          </div>

          <div class="ds-card--item2" v-b-toggle="'sidebar-new-asset-group'">
            <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
          </div>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
      <recommendation-boxes
        v-if="parentEntity"
        :id="parentEntity._id"
        :query="{ ...(currentProduct ? { products: { value: currentProduct, isObject: true } } : {}) }"
        :show="showRecommendationBoxes"
        :level="libraryScopedState"
        :libraryScopedState="libraryScopedState"
        organizationScopedState="organizationAssetGroup"
        @interceptForSetParent="interceptForSetParent"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
        :title="$t('asset-group.recommendations')"
      />
    </div>
  </div>
</template>

<script>
import RecommendationBoxes from "../../entity/component/recommendation-boxes";
import Form from "../organization-asset-group-category-asset-group-form.vue";

export default {
  components: { Form, RecommendationBoxes },
  props: ["product"],
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },

      libraryScopedState: "assetGroup",
      showRecommendationBoxes: undefined,
      nameFilter: undefined,
    };
  },
  computed: {
    parentEntity() {
      return this.$store.getters["assetGroupBoxes/assetGroupCategory"];
    },
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    pagination() {
      return this.$store.getters["organizationAssetGroup/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationAssetGroup/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },
    selectedBox() {
      return this.$store.getters["assetGroupBoxes/assetGroup"];
    },
    selectedBox() {
      return this.$store.getters["assetGroupBoxes/assetGroup"];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.paginate());
      },
    },
    parentEntity: {
      deep: true,
      handler(item) {
        this.paginate();
      },
    },
    async nameFilter(n, o) {
      this.debounceMixin(() => this.handleNameFilterChanged(n, o));
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    redirectToSurvey(item) {
      if (item) {
        this.selectBox(item);
        this.$router.push(`/ddo/asset-group/${item._id}/survey`);
      }
    },
    interceptForSetParent(payload) {
      payload.assetGroupCategory = this.parentEntity;
    },
    selectedBoxStyle(item) {
      let style = "";
      if (this.selectedBox?._id == item._id) {
        style = "bg-main text-white";
      } else if (item.completed) {
        style += " completed";
      }
      return style;
    },

    async paginate() {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        assetGroupCategory: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      if (this.product) {
        request.query = { ...request.query, products: { value: this.product, isObject: true } };
      }
      await this.$store.dispatch("organizationAssetGroup/paginate", request);
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationAssetGroup/delete", item._id);
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },
    copyToForm(item) {
      this.$store.commit(`organizationAssetGroup/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-organization-asset-group");
    },
    edit(item) {
      this.$store.commit("organizationAssetGroup/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group");
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationAssetGroup/resetForm");
    },

    async selectBox(item) {
      return this.$store.dispatch("assetGroupBoxes/selectAssetGroup", item);
    },
    async selectAssetGroupCategoryBox(item) {
      return this.$store.dispatch("assetGroupBoxes/selectAssetGroupCategory", item);
    },

    async onAdminChanged() {
      const selectedAssetGroupCategory = this.$store.getters["assetGroupBoxes/assetGroup"];

      await this.selectAssetGroupCategoryBox(selectedAssetGroupCategory); //ikikere çağırılmasının nedeni toggle yapmak
      await this.selectAssetGroupCategoryBox(selectedAssetGroupCategory);
    },
    copyToForm(item) {
      this.$store.commit(`organizationAssetGroup/copingEntity`, { ...item, libraryItem: item, _id: undefined });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../entity/organization-entities-view.scss");
</style>
